import BigNumber from 'bignumber.js';
import { SocialSecurityForm } from '~/types/document-builder';
import { parseBigNumber } from '../parsing';

interface SocialSecurityTotals {
  amount: BigNumber;
  vatAmount: BigNumber;
  taxableAmount: BigNumber;
  total: BigNumber;
}

export const socialSecurityTotals = (
  socialSecurity: SocialSecurityForm | null,
  maxVat: string,
): SocialSecurityTotals | null => {
  if (!socialSecurity) {
    return null;
  }

  const percentage = BigNumber(socialSecurity.percentage);
  const taxableAmount = parseBigNumber(0)(socialSecurity.taxableAmount).decimalPlaces(2);
  const maxVatBigNumber = BigNumber(maxVat);

  const amount = taxableAmount.multipliedBy(percentage).dividedBy(100).decimalPlaces(2);
  const vatAmount = amount.multipliedBy(maxVatBigNumber.dividedBy(100)).decimalPlaces(2);

  return {
    amount,
    total: amount.plus(vatAmount),
    taxableAmount,
    vatAmount,
  };
};
